import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        light: true,
        themes: {
            light: {

                // Color is applied to selected drop down item
                primary: '#ed1c24',

                // Uncomment this to make things worse
                // 'primary--text': '#FF00FF'
            }
        }
    }
});
